import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyBEu95uJt3Fp8UvSxbHzJg-v3dBj6fLdEg',
  authDomain: 'masasm-2021.firebaseapp.com',
  databaseURL: 'https://masasm-2021-default-rtdb.firebaseio.com',
  projectId: 'masasm-2021',
  storageBucket: 'masasm-2021.appspot.com',
  messagingSenderId: '136469518279',
  appId: '1:136469518279:web:f59b85093b9f5aec072be2',
}

firebase.initializeApp(firebaseConfig)

const firebaseDb = firebase.database()
const firebaseAuth = firebase.auth()

const getDbRef = (dbRef) => {
  const envDbRef = `${process.env.NODE_ENV === 'production' ? 'production' : 'local'}/${dbRef}`
  return firebaseDb.ref(envDbRef)
}

const ChatDb = getDbRef('chat')
const HallOneDb = getDbRef('Hall_A_Question')
const HallTwoDb = getDbRef('Hall_B_Question')
const HallOneChatDb = getDbRef('Hall_A_Chat')
const HallTwoChatDb = getDbRef('Hall_B_Chat')
const NoticeDb = getDbRef('notice')
const NotificationDb = getDbRef('pushNotifications')

const getUniqueSessionDb = (uid) => getDbRef(`uniqueSession/${uid}`)
const getUserCountDb = (uid, path) => getDbRef(`userCount/${path}/${uid}`)
const getUserSessionDb = (uid) => getDbRef(`userSessions/${uid}`)
const getOnlineStatusDb = (uid) => getDbRef(`onlineStatus/${uid}`)
const getLiveCheckInSessionDb = (hallNumber) => getDbRef(`liveCheckInSession/hall-${hallNumber}`)
const getRefreshDb = (uid) => getDbRef(`shouldRefresh/${uid}`)

export {
  firebaseDb,
  firebaseAuth,
  ChatDb,
  HallOneDb,
  HallTwoDb,
  HallOneChatDb,
  HallTwoChatDb,
  NoticeDb,
  NotificationDb,
  getUniqueSessionDb,
  getUserCountDb,
  getUserSessionDb,
  getOnlineStatusDb,
  getLiveCheckInSessionDb,
  getRefreshDb,
}
